import { MachineOptions } from 'xstate'

import {
  QuizEvents,
  QuizMachineContext
} from '@f/applications/QuizApp/stateMachine/initializeQuizMachine'

export const guards: MachineOptions<
  QuizMachineContext,
  QuizEvents
>['guards'] = {
  isNotFirstStep: context => context.currentStepIndex !== 0,
  isLastStepBeforeCheckout: context => {
    const checkoutStartsAt = context.steps.findIndex(({ checkout }) => checkout)
    return context.currentStepIndex === checkoutStartsAt - 1
  },
  canMoveToValidation: context => {
    const validationStartsAt = context.steps.findIndex(
      ({ validation }) => validation
    )
    return context.currentStepIndex === validationStartsAt - 1
  },
  isFirstCheckoutStep: context => {
    const checkoutStartsAt = context.steps.findIndex(({ checkout }) => checkout)
    return context.currentStepIndex === checkoutStartsAt
  },
  isStepWithTransition: context => {
    return Boolean(context.steps[context.currentStepIndex].displayTransition)
  },
  canMoveToSuccess: context => {
    const successStartsAt = context.steps.findIndex(({ success }) => success)

    return context.currentStepIndex === successStartsAt - 1
  }
}
